<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ typeName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">盘点基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="盈亏单号" prop="no">
                <el-input disabled v-model="form.no" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点单号" prop="inventoryNo">
                <el-input disabled v-model="form.inventoryNo" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点人" prop="inventoryUserName">
                <el-input disabled v-model="form.inventoryUserName" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点时间" prop="date">
                <el-input disabled v-model="form.date" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产维度" prop="categoryName">
                <el-input disabled v-model="form.categoryName" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点方式" prop="stocktakingModeName">
                <el-input disabled v-model="form.stocktakingModeName" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点范围" prop="stocktakingRangeName">
                <el-input disabled v-model="form.stocktakingRangeName" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点详情" prop="deptName" v-if="form.stocktakingRange == 1">
                <el-input disabled v-model="form.deptName" style="width:90%"></el-input>
              </el-form-item>
              <el-form-item label="盘点详情" prop="depstocktakingModeIdtName" v-else-if="form.stocktakingRange == 2">
                <el-input disabled v-model="form.depstocktakingModeIdtName" style="width:90%"></el-input>
              </el-form-item>
              <el-form-item label="盘点详情" prop="warehouseName" v-else>
                <el-input disabled v-model="form.warehouseName" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="建卡标志" prop="stocktakingCategoryName">
                <el-input disabled v-model="form.stocktakingCategoryName" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盈亏日期" prop="createdTime">
                <el-input disabled v-model="form.createdTime" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘盈数量" prop="profitNumber">
                <el-input-number disabled v-model="form.profitNumber" :min="0" :precision="2" :controls="false" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘盈金额" prop="profitAmount">
                <el-input-number disabled v-model="form.profitAmount" :min="0" :precision="4" :controls="false" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘亏数量" prop="lossNumber">
                <el-input-number disabled v-model="form.lossNumber" :min="0" :precision="2" :controls="false" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘亏金额" prop="lossAmount">
                <el-input-number disabled v-model="form.lossAmount" :min="0" :precision="4" :controls="false" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盈亏金额" prop="totalAmount">
                <el-input-number disabled v-model="form.totalAmount" :min="0" :precision="4" :controls="false" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input disabled v-model="form.remark" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <AssetInfoEdit ref="AssetInfoEditRef" :isInventory="true" :details="form.details" :canEdit="editMode" :typeName="typeName" :ParentForm="form" :FixedAssetParam="{ deptId: form.deptId }" @autoTotalAmount="autoTotalAmount" />
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetStockProfitLossById,
  SaveStockProfitLoss,
  RejectStockProfitLoss,
} from "@/api";
import { WarehouseOutStockOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import AssetInfoEdit from "@/components/asset-into-edit";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    AssetInfoEdit,
  },
  /** 定义属性 */
  data () {
    return {
      typeName: "资产盈亏",
      form: {},
      WarehouseOutStockOptions: WarehouseOutStockOptions,
      rules: {
        deptName: [
          { required: true, message: "退库科室不能为空", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "退库人不能为空", trigger: "blur" },
        ],
        warehouseName: [
          { required: true, message: "接收库房不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectStockProfitLoss,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetStockProfitLossById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        if (!this.form.details) {
          this.form.details = [];
        }
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
        this.initWorkFlowProperty(this.form);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
      });
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        warehouseId: null,
        warehouseName: null,
        warehouseManagerId: null,
        warehouseManagerName: null,
        backWarehouseId: null,
        backWarehouseName: null,
        backWarehouseManagerId: null,
        backWarehouseManagerName: null,
        userName: null,
        phone: null,
        toTalNumber: null,
        details: [],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveStockProfitLoss(this.form).then((res) => {
          this.$my_confirm("资产转科申请已提交，相关成员审核后 将自动转库！", {
            confirmButtonText: "继续创建",
            cancelButtonText: "返回列表",
            closeOnClickModal: false,
            type: "success",
          })
            .then(() => {
              // 继续创建
              this.InitData();
            })
            .catch(() => {
              // 返回列表
              this.$router.push({ path: this.getMainPath(this.$route.path) });
            });
        });
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 原库房选择
     */
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
    },
    /**
     * 调回库房选择
     */
    backWarehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.backWarehouseId = item.id;
        this.form.backWarehouseManagerId = item.managerId;
        this.form.backWarehouseManagerName = item.managerName;
      }
    },
    autoTotalAmount (e) {
      let toTalNumber = 0;
      let totalAmount = 0;
      this.form.details = e;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        toTalNumber = toTalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.toTalNumber = toTalNumber;
      this.form.totalAmount = totalAmount;
    },
    /**
     * 明细表添加
     */
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.resetDetailFormData();
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.$refs.AssetInfoEditRef.getFixedAssetList();
    this.getWarehouses();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
